import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-skip-backward-icon',
  templateUrl: './skip-backward-icon.component.html',
  styleUrls: ['./skip-backward-icon.component.scss'],
})
export class SkipBackwardIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
